import { render } from "./TestsList.vue?vue&type=template&id=372dea07&scoped=true"
import script from "./TestsList.vue?vue&type=script&lang=js"
export * from "./TestsList.vue?vue&type=script&lang=js"

import "./TestsList.vue?vue&type=style&index=0&id=372dea07&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372dea07"]])

export default __exports__